function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    //加减
    let prods = window.product
function getCur(){
  let color = $('#color div.active').attr('data-val')
  let type = $('#type div.active').attr('data-val')
  console.log(color,type)
  return prods.filter(item=> item.option1 == color && item.option2 == type)[0]
}
     function formatPrice(value) {
    return Math.round(value).toLocaleString('en');
  }
function changePrice(){
  let num = $('#calcNumber').val()
  console.log(getCur())
  let price = ((getCur().price * num / 100).toFixed(0))
  let compare = ((getCur().compare_at_price * num / 100).toFixed(0))
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#new').html(price)
  $('#old').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .sp-free em").html(`${off_font}%OFF`)
}
$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
     changePrice()
    })
    $('.mask').click(function () {
      $('.mask').hide()
    })
    $('.option').click(function () {
      const isDisabled = $(this).hasClass("disbled");
       if(isDisabled) {
        return;
      }
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      let colorOptions = $("#color .option.active").index();
      let typeOptions = $("#type .option.active").index();
      console.log(colorOptions,typeOptions)
      if(colorOptions>0 && typeOptions==0){
        console.log('22222222')
        $("#color .option")
        .siblings()
        .removeClass("active")
        .eq(0)
        .addClass("active");

        $("#color .option")
          .siblings()
          .addClass("disbled")
          .eq(0)
          .removeClass("disbled");
      }else{
        $("#color .option").siblings().removeClass("disbled");
      }
      
      if(typeOptions==0){
        $("#color .option")
          .siblings()
          .addClass("disbled")
          .eq(0)
          .removeClass("disbled");
      }else{
        $("#color .option")
          .removeClass("disbled");
      }
      changePrice()

    })
    let spImgList = [
      "https://cdn.shopify.com/s/files/1/0682/1986/3291/files/20251113-img1.png?v=1763006764",
      "https://cdn.shopify.com/s/files/1/0682/1986/3291/files/20251113-img2.png?v=1763006764",
      "https://soilzen.com/cdn/shop/files/2_b3238e58-c6aa-4122-a973-e18dcf8145d9.jpg?v=1761641152&width=1946",
      "https://cdn.shopify.com/s/files/1/0682/1986/3291/files/1_ab6459f1-3c7d-4907-a186-66af519d727b.jpg?v=1762310470",
      "https://cdn.shopify.com/s/files/1/0682/1986/3291/files/2_7dfbb272-e6a0-42b7-8313-9a61f9bc693e.jpg?v=1762310469",
      "https://cdn.shopify.com/s/files/1/0682/1986/3291/files/3_2cdf2211-e25e-4b2a-9ee0-a2e846309bdc.jpg?v=1762310469",
      // "https://soilzen.com/cdn/shop/files/4_54f59d79-84f1-4bca-8820-d300234af691.jpg?v=1762222768&width=1946",
      // "https://soilzen.com/cdn/shop/files/5_4e0a08ed-6907-4a97-9714-a8d1e876713d.jpg?v=1762222768&width=1946",
      // "https://soilzen.com/cdn/shop/files/6_a6c580ab-eab6-44ab-a5bf-8e4e94b13f74.jpg?v=1762222767&width=1946",
    ]

    // style选项
    let typeOptions = $('#type .option')
    // 切换选项
    typeOptions.click(function () {
      let index = $(this).index()
      $('.top-product img')[0].src = spImgList[index]
      $('.top-product img')[0].srcset = spImgList[index]
    })
    $('#sp-sizes').click(function () {
      $('.mask').css('display', 'flex')
    })
    addCart()
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
         var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 6,
            left: finish[0].offsetLeft + finish.width() / 2 - 9,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop 
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
